import { sortEnabledSections } from '@/lib/utils/dynamic-sections';
import type { HomePageProps } from '@/types';
import { NextRouter, useRouter } from 'next/router';
import { useMemo } from 'react';

/** Same shape as `HomePageProps['variables']` — used by home catch-all static props. */
export type DynamicSectionsVariables = HomePageProps['variables'];

export function useDynamicSections(
  variablesFromPage?: DynamicSectionsVariables | null,
) {
  const router = useRouter() as NextRouter & { components: any };

  const variablesFromRouter = router?.components?.[router.pathname]?.props
    ?.pageProps?.variables as DynamicSectionsVariables | undefined;

  const variables =
    variablesFromPage !== undefined && variablesFromPage !== null
      ? variablesFromPage
      : variablesFromRouter;

  const sections = useMemo(
    () => sortEnabledSections(variables?.layoutSettings?.sections),
    [variables],
  );

  return {
    sections,
    variables,
  };
}
